import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { AllProductsSection } from '../components/AllProductsSection';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { SolutionsPartnersPageHeader } from '../components/headers/SolutionsPartnersPageHeader';
import { SliderSection } from '../components/SliderSection';
import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { Screens } from '../constants/usage';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { BrowsePopularPartnersSliderSection } from './components/BrowsePopularPartnersSliderSection';
import { SuggestedFilters } from './components/SuggestedFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsPartnersPage() {
  const {
    loading,
    error,
    data
  } = useGetSuggestionSections();
  const sections = (data === null || data === void 0 ? void 0 : data.result.sections) || [];
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "1200"
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.SOLUTIONS_PARTNERS,
    children: /*#__PURE__*/_jsxs(DashboardPageWithHero, {
      headerComponent: /*#__PURE__*/_jsx(SolutionsPartnersPageHeader, {}),
      children: [/*#__PURE__*/_jsx(StorefrontPageMetadata, {
        title: unescapedText('marketplaceStorefront.documentHead.solutions.title'),
        metaDescription: unescapedText('marketplaceStorefront.documentHead.solutions.metaDescription')
      }), /*#__PURE__*/_jsx(BrowsePopularPartnersSliderSection, {}), sections.slice(0, 1).map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
        cards: section.cards,
        context: section.context,
        title: section.title,
        sectionIndex: index,
        sectionType: section.sectionType
      }, index)), /*#__PURE__*/_jsx(SuggestedFilters, {}), sections.slice(1, 2).map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
        cards: section.cards,
        context: section.context,
        title: section.title,
        sectionIndex: index,
        sectionType: section.sectionType
      }, index)), /*#__PURE__*/_jsx(AllProductsSection, {
        productType: "SOLUTIONS_PARTNER_PROFILE"
        // Hardcoded index based on figma design layout
        ,
        sectionIndex: 4
      })]
    })
  });
}